import { render, staticRenderFns } from "./NewYearSnowfall.vue?vue&type=template&id=0dd34614"
import script from "./NewYearSnowfall.vue?vue&type=script&lang=js"
export * from "./NewYearSnowfall.vue?vue&type=script&lang=js"
import style0 from "./NewYearSnowfall.vue?vue&type=style&index=0&id=0dd34614&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports